module.exports = __webpack_public_path__ + "kudos_71.svg?e0c82a677b44a65ed9a123c653435ef2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_71.svg
// module id = 174
// module chunks = 0